import MobileOnlyLink from '@acorn-portal/shared/src/components-v2/mobile-only-link';
import { Typography } from '@mui/material';

interface IContactDetailsContent {
	contactNumber: string;
}

/**
 * Fallback content for when no specific MTA access block reason is provided.
 * The number provided should be a valid phone number. It will be prefixed with `tel:` in the mobile link
 * and the number itself will be displayed in the link text.
 */
const ContactDetailsContent = ({ contactNumber }: IContactDetailsContent) => {
	return (
		<Typography>
			Please call us
			{contactNumber ? (
				<>
					{' '}
					on <MobileOnlyLink href={`tel:${contactNumber}`} text={contactNumber} />
				</>
			) : null}{' '}
			if you wish to make changes to your policy details.
		</Typography>
	);
};

export default ContactDetailsContent;
